<template>
  <div class="appointment_suc">
    <van-nav-bar title="申请成功" left-arrow @click-left="back" />
    <div class="wrap">
      <svg-icon icon-class="suc" />
      <p>卡券申请提交成功</p>
      <div class="tip">
        <span>温馨提示：</span>
        <p>1.卡券申请审核中，申请结果将微信通知您，您也可在<a style="color: #3B86FF" @click="onRun">[卡券管理-申请记录]</a>中查询详情</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookSuccess',
  methods: {
    back() {
      this.$router.push({ name: 'user' });
    },
    onRun() {
      this.$router.push({ name: 'vouchers' });
    }
  }
};
</script>

<style lang="less" scoped>
.appointment_suc {
  .svg-icon {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }
  .wrap {
    text-align: center;
    margin-top: 0.7rem;
    font-size: 0.14rem;
    color: #333;
    > p {
      font-size: 0.2rem;
    }
    .tip {
      text-align: left;
      margin-top: 0.2rem;
      padding: 0 0.27rem;
      line-height: 0.28rem;
      span {
        color: #f2b230;
        line-height: 0.3rem;
      }
      p {
        color: #888;
      }
    }
  }
}
</style>
